/**
 * @description フォーム設定
 */
declare let grecaptcha: any;
declare let recaptcha_site_key: any;
declare let recaptcha_action: any;

export function setForm(): void {
  // 入力画面に戻るボタン
  $('#btn_back').click(function () {
    $('input[name="page_name"]').val('input');
    $('#frm').submit();
    return false;
  });
  $('#btn_send').click(function () {
    $('input[name="page_name"]').val('finish');
    grecaptcha.ready(function () {
      grecaptcha.execute(recaptcha_site_key, { action: recaptcha_action }).then(function (token: any) {
        $('#recaptcha_token').val(token);
        $('#frm').submit();
      });
    });
    return false;
  });
}
